import React from 'react';
import { Link } from 'react-router-dom';

export const UNKNOWN_CUSTOMER_NAME = 'ไม่ทราบชื่อ';

export const customerDetailPath = (code, type = 'REGULAR') =>
    `/customerDetail/${encodeURIComponent(String(type || 'REGULAR').toUpperCase())}/${encodeURIComponent(code)}`;

// A customer's name as a link to that customer's detail page. The system code is never shown here —
// it only goes into the href; the detail page shows it under "ข้อมูลระบบ" (click to open).
// No code → nothing to link to, so the name renders as plain text (never a guessed link).
const CustomerLink = ({ name, code, type = 'REGULAR', style, onClick }) => {
    const label = name || UNKNOWN_CUSTOMER_NAME;
    if (!code) return <>{label}</>;
    return (
        <Link to={customerDetailPath(code, type)} onClick={onClick} title="ดูรายละเอียดลูกค้า" style={{ color: 'inherit', borderBottom: '1px dotted #6B6B6B', textDecoration: 'none', ...style }}>
            {label}
        </Link>
    );
};

export default CustomerLink;
